module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAHUlEQVR42mNgYGD4D8XoAEUcXRFWTf/RMFaAIQkA5scN846WZRUAAAAASUVORK5CYII="